$(document).on("click", "a[href^='#']", function(event) {
    event.stopPropagation();
    event.preventDefault();
    $("html, body").animate({
      scrollTop: $(this.getAttribute("href")).offset().top
    }, 1000);
    if (this.getAttribute("href") == "#contact") {
      $("#contact_name").focus();
    }
  });